import { render } from "./TransactionsHistory.vue?vue&type=template&id=4b3c8f5c&scoped=true"
import script from "./TransactionsHistory.vue?vue&type=script&lang=js"
export * from "./TransactionsHistory.vue?vue&type=script&lang=js"

import "./custom-transactions.scss?vue&type=style&index=0&id=4b3c8f5c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3c8f5c"]])

export default __exports__